import { action } from 'mobx';
import { request } from 'utils/api';
import BaseStore from 'common/stores/BaseStore';

export default class ParkingStore extends BaseStore {
  @action
  getRate(ticketId) {
    return request({
      method: 'GET',
      path: `/1/parking/rate-info/${ticketId}`,
    });
  }

  @action
  getTicketInfo(ticketId) {
    return request({
      method: 'GET',
      path: `/1/parking/ticket-info/${ticketId}`,
    });
  }

  @action
  getPaymentIntent(ticketId) {
    return request({
      method: 'GET',
      path: `/1/parking/payment-intent/${ticketId}`,
    });
  }

  @action
  addPayment(ticketId, paymentIntentId) {
    return request({
      method: 'POST',
      path: `/1/parking/add-payment`,
      body: {
        ticketId,
        paymentIntentId,
      },
    });
  }
}
